import {IssueDraftIcon, LockIcon} from '@primer/octicons-react'
import {memo} from 'react'

import type {TitleValueWithContentType} from '../../api/columns/contracts/title'
import {ItemType} from '../../api/memex-items/item-type'
import {assertNever} from '../../helpers/assert-never'
import {type ColumnValue, hasValue} from '../../models/column-value'
import {ItemStateForTitle} from '../item-state'

type MemexItemIconProps = {
  /** Wrapped title value to detect and handle empty state */
  titleColumn: ColumnValue<TitleValueWithContentType>
  /** Whether or not this item should be rendered as blocked */
  isBlocked: boolean
}

export const MemexItemIcon = memo(function MemexItemIconComponent({titleColumn, isBlocked}: MemexItemIconProps) {
  if (!hasValue(titleColumn)) {
    return null
  }

  if (!titleColumn) {
    return null
  }

  switch (titleColumn.value.contentType) {
    case ItemType.RedactedItem:
      return <LockIcon aria-label="Redacted item" />
    case ItemType.DraftIssue:
      return <IssueDraftIcon aria-label="Draft issue" className="fgColor-draft" />
    case ItemType.Issue:
    case ItemType.PullRequest: {
      return <ItemStateForTitle title={titleColumn.value} isBlocked={isBlocked} />
    }
    default:
      assertNever(titleColumn.value)
  }
})
